import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { CartProvider } from "@/contexts/CartContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { StaffProvider } from "@/contexts/StaffContext";
import SessionBootstrap from "@/components/SessionBootstrap";
import Index from "./pages/Index";
import Carta from "./pages/Carta";
import Encargos from "./pages/Encargos";
import Checkout from "./pages/Checkout";
import PedidoConfirmado from "./pages/PedidoConfirmado";
import OrderSuccess from "./pages/OrderSuccess";
import EstadoPedido from "./pages/EstadoPedido";
import PedidoDetalle from "./pages/PedidoDetalle";
import Admin from "./pages/Admin";
import Club from "./pages/Club";
import AvisoLegal from "./pages/AvisoLegal";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import NotFound from "./pages/NotFound";
import { useEffect } from "react";

const queryClient = new QueryClient();

// Función auxiliar para buscar parámetros en cualquier tipo de URL
const getQueryParam = (param: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(window.location.hash.split("?")[1]);
  return searchParams.get(param) || hashParams.get(param);
};

const App = () => {
  // --- LÓGICA DE PERSISTENCIA ROBUSTA ---
  useEffect(() => {
    // 1. Buscamos 'mesa' y 'type' en todas partes
    const mesa = getQueryParam("mesa");
    const type = getQueryParam("type");

    // 2. Si encontramos mesa, la guardamos y LOGUEAMOS para ver si funciona
    if (mesa) {
      sessionStorage.setItem("mesa", mesa);
      console.log("✅ APP: Mesa detectada y guardada:", mesa);
    } else {
      // Si no hay en URL, miramos si ya estaba guardada para no perderla
      const savedMesa = sessionStorage.getItem("mesa");
      if (savedMesa) {
        console.log("ℹ️ APP: Manteniendo mesa anterior:", savedMesa);
      }
    }

    if (type) {
      sessionStorage.setItem("orderType", type);
    }
  }, []);
  // --------------------------------------

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <StaffProvider>
              <CartProvider>
                <SessionBootstrap />
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/carta" element={<Carta />} />
                  <Route path="/encargos" element={<Encargos />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/pedido-confirmado" element={<PedidoConfirmado />} />
                <Route path="/order-success/:orderId" element={<OrderSuccess />} />
                  <Route path="/estado-pedido/:orderId" element={<EstadoPedido />} />
                  <Route path="/pedido/:orderId" element={<PedidoDetalle />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/club" element={<Club />} />
                  <Route path="/aviso-legal" element={<AvisoLegal />} />
                  <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </CartProvider>
            </StaffProvider>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
